// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertMessage_container__uWDoI","icon":"AlertMessage_icon__AbEei","info":"AlertMessage_info__wRKac","no_open_time":"AlertMessage_no_open_time__0wC0q"};